import { render } from "./PraktischeAfsprakenView.vue?vue&type=template&id=0d38e90c"
import script from "./PraktischeAfsprakenView.vue?vue&type=script&lang=js"
export * from "./PraktischeAfsprakenView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__